module.exports = __webpack_public_path__ + "img/prev-arrow-gray.a7afde11.png";